'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import UIFileButton from 'UIComponents/button/UIFileButton';
import { SuspensionTooltip } from 'ui-suspension-banners-lib';
import { FILE_MANAGER_ACCOUNT_VERIFICATION_SOURCE, FILE_MANAGER_WRITE_SCOPE } from 'FileManagerCore/Constants';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import { uploadDashboardFiles } from '../actions/Files';
import UsageTracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
class UploadFilesButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = event => {
      const {
        dispatch,
        currentFolder
      } = this.props;
      const files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }
      UsageTracker.track('fileManagerManageFiles', {
        action: 'upload',
        target: 'upload-files-button',
        count: files.length
      });
      const options = {
        folderId: currentFolder ? currentFolder.get('id') : null
      };
      dispatch(uploadDashboardFiles(files, options));
      this.clearUploadFilesInput(event);
    };
  }
  clearUploadFilesInput(event) {
    event.target.value = null;
  }
  uploadButton() {
    const {
      use,
      children,
      className,
      isReadOnly,
      disabled
    } = this.props;
    return /*#__PURE__*/_jsx(UIFileButton, {
      className: className,
      use: use,
      multiple: true,
      onChange: this.handleChange,
      disabled: isReadOnly || disabled,
      "data-test-id": "upload-files-button",
      size: "small",
      children: children
    });
  }
  render() {
    const {
      isReadOnly,
      disabled,
      disabledTooltip
    } = this.props;
    return /*#__PURE__*/_jsx(SuspensionTooltip, {
      scope: FILE_MANAGER_WRITE_SCOPE,
      source: FILE_MANAGER_ACCOUNT_VERIFICATION_SOURCE,
      children: ({
        scopeDisabled
      }) => scopeDisabled ? this.uploadButton(scopeDisabled) : /*#__PURE__*/_jsx(ScopedFeatureTooltip, {
        titleOverride: disabledTooltip,
        disableOverride: !(isReadOnly || disabled),
        children: this.uploadButton(scopeDisabled)
      })
    });
  }
}
UploadFilesButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  className: PropTypes.string,
  currentFolder: PropTypes.instanceOf(Immutable.Map),
  isReadOnly: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  use: UIFileButton.propTypes.use,
  children: PropTypes.node,
  disabledTooltip: PropTypes.node
};
UploadFilesButton.defaultProps = {
  use: 'primary',
  isReadOnly: false,
  disabled: false
};
const mapStateToProps = state => ({
  isReadOnly: getIsReadOnly(state)
});
export default connect(mapStateToProps)(UploadFilesButton);